import { render, staticRenderFns } from "./ChooseMemberView.vue?vue&type=template&id=3b7a42c3"
import script from "./ChooseMemberView.vue?vue&type=script&lang=ts"
export * from "./ChooseMemberView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports